import React from 'react';
import { PartnerItem, PartnersContainer, PartnersListContainer, Title } from './partnersList.styles';
import { PARTNERS } from './partners.component';
import { useIntl } from 'gatsby-plugin-intl';

const renderPartnerItem = ({ title, icon, url }, index) => (
  <PartnerItem key={index} href={url} title={title} target="_blank">
    {PARTNERS[icon]}
  </PartnerItem>
);

export const PartnersList = ({ id, name, list }) => {
  const intl = useIntl();

  return (
    <PartnersContainer key={id}>
      <Title>{intl.formatMessage({ id: name })}</Title>
      <PartnersListContainer>{list.map(renderPartnerItem)}</PartnersListContainer>
    </PartnersContainer>
  );
};